import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  AddButton,
  CityDropdownForTrip,
  CommonDropdownInfinite,
  CommonInput,
  CrossButton,
  CustomSelect,
} from "components";
import { constant } from "constants/constant";
import AddMapLocationModal from "modals/AddMapLocationModal";
import { UserContext } from "context";
import StorageService from "utils/StorageServices/StorageServices";
import { errorSchema, utils } from "helper";
import { State } from "country-state-city";
import { getStatesData, handleKeyDown } from "_services";
import {
  getBranchDropdownListData,
  getBranchListApi,
  getZoneDropdownListData,
} from "_services/dropdownServices/dropdownService";
import {
  createAddressBook,
  getAddressDetailsApi,
  getPartyAssociateApi,
  updateAddressBookApi,
} from "_services/accountsServices/addressBookService";
import toast from "react-hot-toast";
import { getCityLocationList } from "_services/accountsServices/cityLocationService";
import AddLocationModal from "modals/AddLocationModal";
import { getFirm, getUserFirm } from "_services/accountsServices/firmServices";
import FirmImg from '../../assets/img/firm.png'
import { Link } from 'react-router-dom';

const AddAddressBook = (props) => {
  let {
    isOpen,
    onClose,
    id,
    selectedAssociateParty = "",
    isLocationPoint = "",
    hideAddNewOption = true,
    firmId,
  } = props;

  const initi = {
    name: "",
    category: "",
    associate_party_id: [],
    location_point: "",
    contact_no: "",
    email_id: "",
    address_line1: "",
    address_line2: "",
    state: {},
    city: {},
    pincode: "",
    code: "",
    zone_id: "",
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    gst_no: '',
    gst_treatment_id: {},
    gst_state: {},
    firm_id: {},
  };

  const loadingArray = [
    { label: "Loading point / Unit", value: 1 },
    { label: "Drop point / Consignee", value: 2 },
  ];

  const hasSetInitialParty = useRef(false);
  const { masterData, cities, states, setStates } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState(1);
  const [showGoogleMapModal, setShowGoogleMapModal] = useState(false);
  const [form, setForm] = useState(initi);
  const [formError, setFormError] = useState("");
  const [stateValue, setStateValue] = useState();
  const [partyCategory, setPartyCategory] = useState([]);
  const [allZoneList, setAllZoneList] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partyAssociateList, setPartyAssociateList] = useState([]);
  const [listData, setListData] = useState({
    categoryList: [],
    zoneList: [],
    branchList: [],
  });
  const [isProgrammaticUpdate, setIsProgrammaticUpdate] = useState(false);
  const [mapAddressData, setMapAddressData] = useState("");
  const [openLoction, setOpenLoction] = useState(false)
  const [addRecord, setAddRecord] = useState("")
  const isInitialFetch = useRef(true);

  const [firmDataList, setFirmDataList] = useState([]);

  useEffect(() => {
    if (!isOpen?.create_new) {
      const validCategories = [1, 2, 3];

      if (!isProgrammaticUpdate) {

        setForm((prevForm) => {
          const updatedForm = { ...prevForm };
          if (prevForm?.category) {
            updatedForm.associate_party_id = [];
            updatedForm.location_point = isLocationPoint ? isLocationPoint : prevForm.category === 1 ? 1 : 0;
          }
          return updatedForm;
        });
      }

      if (validCategories.includes(form?.category)) {
        // getPartyAssociate(form?.category);
      } else {
        setPartyAssociateList([]);
      }

      setIsProgrammaticUpdate(false);
    }
  }, [form?.category, isOpen?.create_new]);

  useEffect(() => {
    if (stateValue) {
      handleOnChange("state", {
        label: stateValue?.name,
        value: stateValue?.name,
        lat: String(stateValue?.latitude) || "",
        long: String(stateValue?.longitude) || "",
      });
    }
  }, [stateValue]);

  useEffect(() => {
    // if(!isOpen?.create_new){
    if (id?.id) {
      fetchData();
    } else {
      fetchData();
    }
    // }
  }, [masterData, id]);

  useEffect(() => {
    //&& !isOpen?.create_new
    if (listData?.categoryList?.length && id?.id) {
      getAddressBook(id?.id);
    }
  }, [listData]);

  // useEffect(() => {

  //   setForm((prevForm) => {
  //     const updatedForm = {
  //       ...prevForm,
  //       location_point: isLocationPoint
  //         ? isLocationPoint
  //         : prevForm?.location_point,
  //     };

  //     if (partyAssociateList?.length > 0 && selectedAssociateParty?._id) {
  //       const data = partyAssociateList.find(
  //         (el) => el?._id === selectedAssociateParty?._id
  //       );

  //       updatedForm.associate_party_id = [{ ...selectedAssociateParty }];
  //     }


  //     return updatedForm;
  //   });
  // }, [selectedAssociateParty,partyAssociateList]);

  // एक ref बनाएं track करने के लिए


  useEffect(() => {
    // सिर्फ पहली बार run करें
    if (hasSetInitialParty.current) return;

    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        location_point: isLocationPoint
          ? isLocationPoint
          : prevForm?.location_point,
      };

      if (partyAssociateList?.length > 0 && selectedAssociateParty?._id) {
        const data = partyAssociateList.find(
          (el) => el?._id === selectedAssociateParty?._id
        );

        // सिर्फ अगर पहले से selected नहीं है तो set करें
        if (!updatedForm.associate_party_id?.some(p => p._id === selectedAssociateParty._id)) {
          updatedForm.associate_party_id = [
            ...(updatedForm.associate_party_id || []),
            { ...selectedAssociateParty }
          ];
        }

        hasSetInitialParty.current = true; // mark as set
      }

      return updatedForm;
    });
  }, [selectedAssociateParty, partyAssociateList]);



  useEffect(() => {
    // Only fetch manually if NOT editing (since dropdown will fetch on mount during edit)
    if (!id?.id && form?.category && listData?.categoryList?.length) {
      fetchUsers("", 1, 20);
    }
  }, [form?.category, listData?.categoryList?.length]);



  // const fetchUsers = async (search, page, limit) => {
  //   // Prevent duplicate initial calls during edit
  //   if (isInitialFetch.current && id?.id && !search && page === 1) {
  //     isInitialFetch.current = false;
  //   }

  //   const res = await getPartyAssociateApi({
  //     company_id: StorageService.getCompanyId(),
  //     offset: page,
  //     limit,
  //     search,
  //     category: form?.category,
  //   });

  //   if (res?.responseCode === 200) {
  //     setPartyAssociateList(res?.data?.list);
  //     return {
  //       items: res?.data?.list,
  //       total: res?.data?.total_record,
  //     };
  //   } else {
  //     toast.error(res?.responseMessage);
  //   }
  // };

  const fetchUsers = async (search, page, limit) => {
    // Prevent duplicate initial calls during edit
    if (isInitialFetch.current && id?.id && !search && page === 1) {
      isInitialFetch.current = false;
    }

    const res = await getPartyAssociateApi({
      company_id: StorageService.getCompanyId(),
      firm_id: form?.firm_id?.value ? form?.firm_id?.value : StorageService.getFirmId(),
      offset: page,
      limit,
      search,
      category: form?.category,
    });

    if (res?.responseCode === 200) {
      // ✅ Accumulate items instead of replacing
      setPartyAssociateList((prevList) => {
        // Reset on first page or new search
        if (page === 1) {
          return res?.data?.list;
        }
        // Append new items for subsequent pages
        return [...prevList, ...res?.data?.list];
      });

      return {
        items: res?.data?.list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const fetchFromCity = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const getAddressBook = useCallback(async (id) => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      addressbook_id: id,
    };

    const res = await commonFetchFuction(getAddressDetailsApi, payload);

    const details = res?.data?.book_detail;

    const validationCheck = (category, location) => {
      const validCategories = [1, 2, 3];

      if (validCategories.includes(category)) {
        if (location == 0) {
          return 1;
        } else {
          return location;
        }
      } else {
        return location;
      }
    };

    const zoneCheck = (category) => {
      if (!category) {
        return listData?.zoneList[0]?.value;
      } else {
        return category;
      }
    };

    const branchCheck = (category) => {
      if (!category) {
        return listData?.branchList[0]?.value;
      } else {
        return category;
      }
    };

    setIsProgrammaticUpdate(true);
    const assoList = details?.associate_party_id?.map((i) => ({
      ...i,
      label: i?.name,
      value: i?._id,
    }));
  
    setForm((prevForm) => ({
      ...prevForm,
      firm_id: {
        label: details?.firm_id?.firm,
        value: details?.firm_id?._id
      },
      category: Number(details?.category) || "",
      associate_party_id: details?.associate_party_id || [],
      location_point: validationCheck(
        details?.category,
        details?.location_point
      ),
      branch_id: branchCheck(details?.branch_id?._id) || "",
      name: details?.name || "",
      address_line1: details?.address_line1 || "",
      address_line2: details?.address_line2 || "",
      city: details?.city?.value ? details?.city : {},
      state: details?.state || "",
      pincode: details?.pincode || "",
      contact_no: details?.contact_no || "",
      email_id: details?.email || "",
      code: details?.code || "",
      zone_id: zoneCheck(details?.zone_id?._id) || "",
      gst_no: details?.gst_type !== null ? details?.gst_no : '',
      gst_treatment_id: details?.gst_type ? masterData?.gst_type_list?.filter((element) => (element?.id === details?.gst_type)).map((el) => {
        return {
          label: el?.name,
          value: el?.id
        }
      })[0] : masterData?.gst_type_list?.map((el) => {
        return {
          label: el?.name,
          value: el?.id
        }
      })[0],
      gst_state: details?.gst_state?.label ? details?.gst_state : {},
    }));
  }, [])

  const fetchData = async () => {
    try {
      // setLoading(true);
      const [zoneRes, branchRes] = await Promise.all([
        getZoneList(),
        getBranchList(),
      ]);

      const zoneList = formatList(zoneRes?.data?.zone_list, "name", "_id");
      const branchList = formatList(
        branchRes?.data?.branch_list,
        "branch",
        "_id"
      );

      const categoryList = formatList(
        masterData?.addressbook_category_list,
        "name",
        "id"
      );

      setListData({
        categoryList,
        zoneList,
        branchList,
      });

      if (!id?.id) {
        setInitialFormValues(categoryList, zoneList, branchList);
      }
      // setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const formatList = (list, labelKey, valueKey, defaultOption = null) => {
    const formattedList = list?.map((item) => ({
      ...item,
      label: item[labelKey],
      value: item[valueKey],
    }));
    return defaultOption
      ? [{ label: defaultOption, value: "" }, ...formattedList]
      : formattedList;
  };

  const setInitialFormValues = (categoryList, zoneList, branchList) => {
    handleOnChange("category", categoryList[0]?.value || "");
    handleOnChange("zone_id", zoneList?.[0]?.value || "");

    if (branchList.length == 1) {
      handleOnChange("branch_id", branchList[0]?.value || "");
    }
  };

  const commonFetchFuction = async (
    apiMethod,
    payload = {},
    transformer = (res) => res
  ) => {
    try {
      const res = await apiMethod(payload);
      if (res?.responseCode === 200) {
        return transformer(res);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.addAddressBook
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const getStatesByApi = async (countryCode, stateCode) => {
    try {
      let data = {
        countryCode: countryCode ? countryCode : "IN",
        stateCode: stateCode ? stateCode : "",
      };
      let response = await getStatesData(data);
      if (response?.responseCode === 200) {
        if (countryCode && stateCode) {
          setStateValue(response?.data[0]);
          return response?.data[0];
        } else {
          const optionsState = response?.data?.map((d) => {
            return {
              ...d,
              label: d?.name,
              value: d?.name
            };
          });

          StorageService.setStates(JSON.stringify([...optionsState]))
          setStates([...optionsState]);
        }

      } else {
        if (response) {
          toast.error(response?.responseMessage)
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  const handleCityChange = (data) => {
    handleOnChange("city", {
      label: data?.name,
      value: data?.name,
      lat: String(data?.latitude) || "",
      long: String(data?.longitude) || "",
    });

    getStatesByApi(data?.countryCode, data?.stateCode);

    // const stateDetails = State.getStateByCodeAndCountry(
    //   data?.stateCode,
    //   data?.countryCode
    // );
    // setStateValue(stateDetails);
  };

  const getPartyAssociate = async (category) => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        category,
        limit: "",
        offset: "",
        search: "",
      };

      const res = await commonFetchFuction(getPartyAssociateApi, object);
      if (res?.responseCode == 200) {
        const list = res?.data?.list?.map((el) => {
          return {
            ...el,
            label: el?.name,
            value: el?._id,
          };
        });
        setPartyAssociateList([...list]);
      }
    } catch (error) {
      // throw error;
    }
  };

  const getZoneList = async () => {
    let object = { company_id: StorageService.getCompanyId() };
    return commonFetchFuction(getZoneDropdownListData, object);
  };

  const getBranchList = async () => {
    let object = { company_id: StorageService.getCompanyId(), firm_id: form?.firm_id?.value ? form?.firm_id?.value : '' };
    return commonFetchFuction(getBranchDropdownListData, object);
  };

  const handleClick = async (e, action) => {
    e.preventDefault();
    const validationResult = await utils?.checkFormError(
      form,
      errorSchema.addAddressBook
    );
    setAddRecord(action)
    if (validationResult == true) {
      setLoading(true);
      await apiCallingFunction(action);
      setFormError("");
    } else {
      setFormError(validationResult);
      setLoading(false);
    }
  };

  const handleClickContinue = async (e) => {
    e.preventDefault();

    const validationResult = await utils.checkFormError(
      { ...form },
      errorSchema.addAddressBookContinue
    );
    if (validationResult == true) {
      setActiveTab(activeTab + 1);
    } else {
      setFormError(validationResult);
    }
  };

  const handleClickContinueActiveTab = async (e) => {
    e.preventDefault();

    const validationResult = await utils.checkFormError(form, errorSchema.consigneeSchemaForSecondActiveTab);
    if (validationResult == true) {
      setActiveTab(activeTab + 1);
    } else {
      setFormError(validationResult);
    }
  };

  const changeActiveTab = async (event, value) => {
    event.preventDefault();
    if (value > activeTab) {
      const validationResult = await utils.checkFormError(
        form,
        errorSchema.addAddressBookContinue
      );
      if (validationResult === true) {
        setActiveTab(value);
      } else {
        setFormError(validationResult);
      }
    } else {
      const validationResult = await utils.checkFormError(form, errorSchema.addAddressBookContinue);
      if (validationResult === true) {
        setActiveTab(value);
      } else {
        setFormError(validationResult);
      }
    }
  };

  const apiCallingFunction = async (action) => {
    try {

      let object = {
        ...form,
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
        gst_treatment_id: form?.gst_treatment_id?.value,
        gst_state: {
          value: form?.gst_state?.value,
          label: form?.gst_state?.label,
        },
      };

      let updateObject = {
        ...form,
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
        gst_treatment_id: form?.gst_treatment_id?.value,
        gst_state: {
          value: form?.gst_state?.value,
          label: form?.gst_state?.label,
        },
        addressbook_id: props?.id?.id,
      };

      const res = props?.id?.id
        ? await updateAddressBookApi(updateObject)
        : await createAddressBook(object);
      if (res?.responseCode == 200) {
        clearAll();
        setLoading(false);
        toast.success("Address Created Successfully");
        if (action == "add") {
          onClose();
          clearAll();
          if (props?.id?.title == "plan") {
            props?.callBackAddressData(res);
          } else {
            props?.callBackAddressData(res?.data?.addressbook);
          }
        } else {
          setActiveTab(1);
          clearAll();
        }
      } else {
        if (res?.responseMessage) {
          toast.error(`${res?.responseMessage}`);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setIsButtonDisabled(false);
    }
  };

  // const callBackDataMap = async (data) => {
  //   setMapAddressData(data);
  //   if (!data) return;
  //   const { address_components: addressComponents, geometry: geometry } = data;
  //   const { city, state, postalCode, country } = parseAddressComponents(
  //     addressComponents,
  //     geometry
  //   );
  //   const stateValue = await getStatesByApi(
  //     country?.country_code,
  //     state?.value
  //   );

  //   if (city || state || postalCode || country || stateValue) {
  //     const object = {
  //       city: city,
  //       state: {
  //         label: stateValue?.name,
  //         value: stateValue?.name,
  //         lat: String(stateValue?.latitude),
  //         long: String(stateValue?.longitude),
  //       },
  //       address_line1: ` ${city?.label}, ${state?.label} ${postalCode}, ${country?.country}`,
  //       pincode: postalCode,
  //     };

  //     const validationResult = await utils.checkFormError(
  //       form,
  //       object,
  //       errorSchema.addAddressBookContinue
  //     );

  //     if (validationResult === false) {
  //       setFormError(validationResult);
  //     }

  //     setForm({
  //       ...form,
  //       city: city,
  //       state: {
  //         label: stateValue?.name,
  //         value: stateValue?.name,
  //         lat: String(stateValue?.latitude),
  //         long: String(stateValue?.longitude),
  //       },
  //       address_line1: ` ${city?.label}, ${state?.label} ${postalCode}, ${country?.country}`,
  //       pincode: postalCode,
  //     });
  //   }
  // };

  const callBackDataMap = async (data) => {
    setMapAddressData(data);

    const { address_components: addressComponents, geometry } = data;
    const { city, state, postalCode, country } = parseAddressComponents(addressComponents, geometry);

    // Only proceed if we have at least state or city
    if (!city && !state) {
      console.warn("Insufficient address data: city and state are missing.");
      return;
    }

    try {
      const stateValue = await getStatesByApi(country?.country_code, state?.value);

      // Build safe strings without showing 'undefined'
      const cityLabel = city?.label || "";
      const stateLabel = state?.label || stateValue?.name || "";
      const pincodeStr = postalCode ? ` ${postalCode}` : "";
      const countryName = country?.country || "";

      const addressLine1 = [cityLabel, stateLabel, pincodeStr, countryName]
        .filter(Boolean) // Remove empty or undefined parts
        .join(", ")
        .trim();

      const object = {
        city: city || null,
        state: stateValue
          ? {
            label: stateValue.name,
            value: stateValue.name,
            lat: String(stateValue.latitude || ""),
            long: String(stateValue.longitude || ""),
          }
          : state || null,
        address_line1: addressLine1,
        pincode: postalCode || "",
      };

      const validationResult = await utils.checkFormError(
        form,
        object,
        errorSchema.addAddressBookContinue
      );

      if (validationResult === false) {
        setFormError(validationResult);
      }

      setForm({
        ...form,
        ...object,
      });
    } catch (error) {
      console.error("Error processing address data:", error);
    }
  };

  const parseAddressComponents = (addressComponents, geometry) => {
    let city = "";
    let state = "";
    let postalCode = "";
    let country = "";
    addressComponents?.map((component) => {
      if (component.types.includes("locality")) {
        city = {
          label: component.long_name,
          value: component?.short_name,
          lat: String(geometry?.location?.lat()) || null,
          long: String(geometry?.location?.lng()) || null,
        };
      } else if (component.types.includes("administrative_area_level_1")) {
        state = {
          label: component.long_name,
          value: component?.short_name,
          lat: geometry?.location?.lat() || null,
          long: geometry?.location?.lng() || null,
        };
      } else if (component.types.includes("postal_code")) {
        postalCode = component.long_name;
      } else if (component.types.includes("country")) {
        country = {
          country: component.long_name,
          country_code: component.short_name,
        };
      }
    });

    return { city, state, postalCode, country };
  };

  const addNewItemHandler = (e) => {

    setOpenLoction(true)
  }


  const callBackDataMaps = async (data) => {
    handleCityChange(data, "city")
    fetchFromCity()

  }

  const clearAll = () => {
    setForm({
      ...form,
      name: "",
      category: 1,
      associate_party_id: [],
      contact_no: "",
      email_id: "",
      address_line1: "",
      address_line2: "",
      state: {},
      city: {},
      pincode: "",
      code: "",
      zone_id: "",
      company_id: StorageService.getCompanyId(),
    });
  };

  let gmapLocate = {
    isOpen: showGoogleMapModal,
    closeModal: (e) => setShowGoogleMapModal(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Select on Map",
    submitTitle: "Add Location",
    callBackDataMap: callBackDataMap,
    mapAddressData: mapAddressData,
  };

  let gmapLocates = {
    isOpen: openLoction,
    closeModal: (e) => setOpenLoction(false),
    modalMainClass: "_dashCommon_Modal _mdModalLoction",
    modalTitle: 'Add Location',
    submitTitle: 'Add Location',
    callBackDataMap: callBackDataMaps
  };

  useEffect(() => {
    if (form?.gst_treatment_id?.value === 1) {
      setForm((s) => ({
        ...s,
        gst_no: ''
      }))
    }
  }, [form?.gst_treatment_id])

  useEffect(() => {
    if (!id?.id && !isOpen?.create_new) {
      if (masterData?.gst_type_list?.length > 0 && states?.length > 0) {
        setForm((s) => ({
          ...s,
          gst_state: form?.state?.label ? {
            label: form?.state?.label ? form?.state?.label : '',
            value: form?.state?.value ? form?.state?.value : '',
          } : {},
          gst_treatment_id: masterData?.gst_type_list?.map((el) => {
            return {
              label: el?.name,
              value: el?.id
            }
          })[0],
          tds_deduction: masterData?.tds_section_list?.map((el) => {
            return {
              label: el?.name,
              value: el?.id
            }
          })[0],
          company_id: StorageService.getCompanyId()
        }));
      }
    }
  }, [masterData?.gst_type_list?.length > 0, states?.length > 0, StorageService.getCompanyId, form?.state, isOpen?.create_new]);

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...form, [name]: item };
    if (name === 'firm_id') {
      stateObj['associate_party_id'] = [];
      stateObj['branch_id'] = "";
    }
    setForm(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.addAddressBookContinue);
      if (validationResult === true) {
        setFormError({});
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleOnChangeForSecoudActiveTab = async (name, value) => {
    const stateObj = { ...form, [name]: value };

    if (name === "gst_no") {
      let gstCode = parseInt(value.slice(0, 2), 10);
      stateObj['gst_state'] = utils.codeToStateNameObject[gstCode];
    }
    setForm(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.consigneeSchemaForSecondActiveTab);
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  useEffect(() => {
    if (isOpen?.create_new === true) {
      let gstNumber = (isOpen?.gst_no != '' && isOpen?.gst_no != null && isOpen?.gst_no != undefined) ? isOpen?.gst_no : '';
      let gstObj = gstNumber ? { label: "Registered Regular", value: 2 } : { label: "Unregistered Business", value: 1 };

      setForm((s) => ({
        ...s,
        name: isOpen?.name,
        firm_id: {
          label: isOpen?.firm_id?.firm,
          value: isOpen?.firm_id?._id
        },
        category: "",
        associate_party_id: [{ name: isOpen?.consignor_list?.name, _id: isOpen?.consignor_list?._id }],
        location_point: isOpen?.location_point,
        contact_no: "",
        email_id: "",
        address_line1: isOpen?.address_line1,
        address_line2: "",
        city: isOpen?.city,
        state: isOpen?.state?.label ? isOpen?.state : {},
        pincode: isOpen?.pincode,
        code: "",
        zone_id: "",
        branch_id: "",
        company_id: StorageService.getCompanyId(),
        gst_state: isOpen?.state?.label ? isOpen?.state : {},
        gst_treatment_id: gstObj,
        gst_no: gstNumber,
        tds_deduction: masterData?.tds_section_list?.map((el) => {
          return {
            label: el?.name,
            value: el?.id
          }
        })[0]
      }));
    }
  }, [isOpen?.create_new, masterData]);

  const getDataFirmList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
      }
      const res = await getUserFirm(object);
      if (res?.responseCode == 200) {
        let apiData = res?.data?.firm_list?.map((el) => {
          return {
            label: el?.firm_id?.firm,
            value: el?.firm_id?._id,
          }
        })
        setFirmDataList(apiData);
        if (!isOpen?._id) {
          if (apiData?.length === 1) {
            setForm((s) => ({
              ...s,
              firm_id: apiData[0]
            }))
          } else {
            setForm((s) => ({
              ...s,
              firm_id: {}
            }))
          }
        }
      }
    } catch (error) {
    }
  }

  const fetchBranch = async (search, page, limit) => {
    const res = await getBranchListApi({
      company_id: StorageService.getCompanyId(),
      firm_id: form?.firm_id?.value,
      offset: page,
      limit,
      search,
    });

    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.branch_list?.map((i) => ({
        ...i,
        label: i?.branch,
        value: i?._id
      }));

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataFirmList();
    getStatesByApi();
  }, [])

  // useEffect(() => {
  //   if (firmId) {
  //     setForm((s) => ({
  //       ...s,
  //       firm_id: { label: firmId?.firm, value: firmId?._id }
  //     }))
  //   } else if (firmDataList?.length > 0 && !id?.id) {
  //     let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
  //     setForm((s) => ({
  //       ...s,
  //       firm_id: findObject?.value ? findObject : {}
  //     }))
  //   }
  // }, [StorageService.getFirmId(), firmDataList, id])

  useEffect(() => {

    if (firmDataList?.length > 0 && !id?.id) {
      const storageFirmId = StorageService.getFirmId();

      let findObject = firmDataList.find((el) => el?.value === storageFirmId);

      const branchFirm = firmId?._id;
      let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

      setForm((s) => ({
        ...s,
        ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
      }));
    }
  }, [StorageService.getFirmId(), firmDataList, id?.id, firmId?._id]);

  return (
    <>
      <div className={form?.firm_id?.label ? `offcanvas-header offcan_header` : `offcanvas-header`}>
        {form?.firm_id?.label ?
          <div>
            <h5 className="offcanvas-title">{`${id?.id && !id.view ? "Edit" : id?.id && id.view ? "View" : "Add"} Address`}</h5>
            <p className='offcanvas_heading_head'>
              <img src={FirmImg} className='firm_icon_img' /> {" "}
              {form?.firm_id?.label ? form?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
            </p>
          </div>
          :
          <h5 className="offcanvas-title">{`${id?.id && !id.view ? "Edit" : id?.id && id.view ? "View" : "Add"} Address`}</h5>
        }
        <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
          <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black" />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className="pr_procssBx">
          <div className="pr_procssBx_grid">
            {!id?.id && !isOpen?.create_new && firmDataList?.length > 1 && <div className='singleDiv'>
              <CustomSelect
                options={firmDataList}
                label="Select Firm"
                placeholder="Select Firm"
                name="firm_id"
                value={form?.firm_id}
                error={formError["firm_id.label"]}
                onSelect={(data) => onhandleSelect(data, 'firm_id')}
                disabled={hideAddNewOption ? false : (form?.firm_id?.value ? true : false)}
              />
            </div>}

            <div className="singleDiv">
              <CommonInput
                type="text"
                placeholder="Address Name"
                label="Address Name"
                labelRedStar={true}
                name="name"
                maxLength="40"
                onInput={utils.maxLengthCheck}
                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                // onChange={({ target: { name, value } }) => {
                //   handleOnChange(name, value);
                // }}
                value={form?.name}
                focus={!!(typeof formError === "object" && formError?.name)}
                error={!!(typeof formError === "object") ? formError?.name : ""}
                disabled={id?.view}
              />
            </div>

            <div className="singleDiv">
              <CustomSelect
                // placeholder="Party"
                labelRedStar={true}
                label="Category"
                options={listData?.categoryList}
                onSelect={(data) => {
                  handleOnChange("category", data.value);
                }}
                disabled={
                  id?.view ? true : selectedAssociateParty?._id ? true : (isOpen?.create_new ? true : false)
                }
                value={
                  form?.category
                    ? listData?.categoryList?.find(
                      (i) => i.value == form?.category
                    )
                    : { label: "", value: "" }
                }
                focus={!!(typeof formError === "object" && formError?.category)}
                error={
                  !!(typeof formError === "object") ? formError?.category : ""
                }
              />
            </div>


            {[1, 2, 3].includes(form?.category) && (
              <div className="singleDiv">
                <CommonDropdownInfinite
                  key={form?.category}
                  label={`Associate ${form?.category == 1
                    ? "Party"
                    : form?.category == 2
                      ? "Supplier"
                      : "Vender"
                    }`}
                  fetchData={fetchUsers}
                  onChange={(data) => {
                    const list = data?.map((i) => ({
                      name: i?.name,
                      _id: i?._id,
                    }));
                    handleOnChange("associate_party_id", list);
                  }}
                  selectedItems={
                    form?.associate_party_id ? form?.associate_party_id : []
                  }
                  isMulti={true}
                  disabled={id?.view}
                  error={!!formError.associate_party_id}
                  errorMessage={formError.associate_party_id}
                />{" "}
              </div>
            )}
            {form?.category == 1 && (
              <div className="singleDiv">
                <div className="d-flex gap-4">
                  {loadingArray.map((i, index) => (
                    <div className="_dualCheckr_bx" key={i?.label}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        // id='(+) Balance'
                        type="radio"
                        name="location_point"
                        checked={i.value == form.location_point}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                        disabled={id?.view || isLocationPoint != ''}
                      />
                      <label
                        htmlFor={i?.label}
                        // label="(+) Balance"
                        className="form-check-label"
                      >
                        {i?.label}
                        {/* (+) Balance */}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="addPr_flBx __newTabs_bx">
          <ul className="nav nav-tabs cstNew_tabs" id="addParty" role="tablist">
            {constant.addAddressBookTabs?.map((item, indx) => (
              <li
                className="nav-item"
                role="presentation"
                key={indx + item?.value}
              >
                <button
                  className={
                    "nav-link " + (activeTab === item?.id ? "active" : "")
                  }
                  type="button"
                  aria-selected={activeTab === item?.id}
                  onClick={(e, val) => changeActiveTab(e, item.id)}
                >
                  {item?.title}
                </button>
              </li>
            ))}
          </ul>

          {activeTab === 1 && (
            <div className="pr_procssBx" id="addPartyContent">
              <div className="pr_procssBx_grid">
                {!id?.view ? (
                  <div className="singleDiv">
                    <button
                      className="gogLocation_btn"
                      onClick={() => setShowGoogleMapModal(true)}
                      disabled={id?.view}
                    >
                      <div>
                        Select From Google <span className="valId">*</span>
                      </div>
                    </button>
                  </div>
                ) : (
                  <></>
                )}

                <div className="singleDiv">
                  <div className="h4Head">Add Address</div>
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    placeholder="Address"
                    label="Address Line 1"
                    name="address_line1"
                    value={form.address_line1}
                    focus={
                      !!(
                        typeof formError === "object" &&
                        formError?.address_line1
                      )
                    }
                    error={
                      !!(typeof formError === "object")
                        ? formError?.address_line1
                        : ""
                    }
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    disabled={id?.view}
                  />
                </div>

                <div className="singleDiv">
                  <CityDropdownForTrip
                    key={`fromLoction`}
                    label="City "
                    placeholder="Select a city"
                    fetchData={fetchFromCity}
                    isAddButton={true}
                    addButtonAction={(e) => addNewItemHandler(e)}
                    pageSize={20}
                    onChange={(data) => handleCityChange(data, "city")}
                    disabled={id?.view}
                    selectedItem={form?.city}
                    error={!!formError["city.label"]}
                    errorMessage={
                      formError["city.label"]
                    }
                    withState={false}
                  />
                </div>

                <div className="halfDiv">
                  <CommonInput
                    type="text"
                    placeholder="State"
                    label="State"
                    name="state"
                    disabled={true}
                    value={form?.state?.label}
                    focus={
                      !!(
                        typeof formError === "object" &&
                        formError["state.label"]
                      )
                    }
                    error={
                      !!(typeof formError === "object")
                        ? formError["state.label"]
                        : ""
                    }
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                  />
                </div>

                <div className="halfDiv">
                  <CommonInput
                    type="text"
                    placeholder="PIN Code"
                    label="PIN Code"
                    name="pincode"
                    maxLength={6}
                    value={form.pincode}
                    focus={
                      !!(typeof formError === "object" && formError?.pincode)
                    }
                    error={
                      !!(typeof formError === "object")
                        ? formError?.pincode
                        : ""
                    }
                    onChange={({ target: { name, value } }) => {
                      if (/^\d*$/.test(value)) {
                        handleOnChange(name, value);
                        // setPhoneError("");
                      }
                    }}
                    disabled={id?.view}
                  />
                </div>

                <div className="singleDiv">
                  <div className="h4Head">Other Contact</div>
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    placeholder="Contact Number"
                    label="Contact Number"
                    name="contact_no"
                    maxLength="16"
                    value={form.contact_no}
                    focus={
                      !!(typeof formError === "object" && formError?.contact_no)
                    }
                    error={
                      !!(typeof formError === "object")
                        ? formError?.contact_no
                        : ""
                    }
                    // onChange={({ target: { name, value } }) => {
                    //   if (/^\d*$/.test(value)) {
                    //     handleOnChange(name, value);
                    //     // setPhoneError("");
                    //   }
                    // }}
                    onChange={({ target: { name, value } }) => {
                      // Remove all non-digit characters (anything that's not 0-9)
                      let cleanedValue = value.replace(/\D/g, '');

                      // Remove '91' or '+91' from start if present and extra digits exist
                      if (cleanedValue.startsWith('91') && cleanedValue.length > 10) {
                        cleanedValue = cleanedValue.substring(2);
                      }

                      // Allow only if the result is 10 digits or fewer
                      if (/^\d{0,10}$/.test(cleanedValue)) {
                        handleOnChange(name, cleanedValue);
                      }
                    }}
                    disabled={id?.view}
                  />
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="email"
                    placeholder="Email ID"
                    label="Email ID"
                    name="email_id"
                    value={form.email_id}
                    focus={
                      !!(typeof formError === "object" && formError?.email_id)
                    }
                    error={
                      !!(typeof formError === "object")
                        ? formError?.email_id
                        : ""
                    }
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    disabled={id?.view}
                  />
                </div>
              </div>
            </div>
          )}

          {activeTab === 2 && (
            <div className='pr_procssBx' id="addPartyContent">
              <div className='pr_procssBx_grid'>
                <div className='singleDiv'>
                  <CustomSelect
                    options={masterData?.gst_type_list?.map((el) => {
                      return {
                        label: el?.name,
                        value: el?.id
                      }
                    })}
                    name="gst_treatment_id"
                    label="GST Type"
                    value={form?.gst_treatment_id}
                    error={formError["gst_treatment_id.label"]}
                    onSelect={(data) => onhandleSelect(data, 'gst_treatment_id')}
                    placeholder="Select GST Type"
                    disabled={id?.view}
                  />
                </div>

                {
                  (form?.gst_treatment_id?.value == '2' || form?.gst_treatment_id?.value == '3') && (
                    <div className='singleDiv'>
                      <CommonInput
                        type="text"
                        placeholder="GST Number e.g. 09AAACH7409R1RR"
                        label='GST Number'
                        name='gst_no'
                        maxLength={15}
                        value={form.gst_no}
                        onChange={({ target: { name, value } }) =>
                          handleOnChangeForSecoudActiveTab(name, value.toUpperCase())
                        }
                        focus={!!(typeof formError === "object" && formError?.gst_no)}
                        error={!!(typeof formError === "object") ? formError?.gst_no : ""}
                        disabled={id?.view}
                      />
                    </div>
                  )
                }

                <div className='singleDiv'>
                  <CustomSelect
                    options={states?.map((el) => {
                      return {
                        label: el?.name,
                        value: el?.name
                      }
                    })}
                    name="gst_state"
                    label="GST State"
                    value={form?.gst_state}
                    error={formError["gst_state.label"]}
                    onSelect={(data) => onhandleSelect(data, 'gst_state')}
                    placeholder="Select GST State"
                    disabled={id?.view || form.gst_no}
                  />
                </div>

              </div>
            </div>
          )}

          {activeTab === 3 && (
            <div className="pr_procssBx" id="addPartyContent">
              <div className="pr_procssBx_grid">
                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Code"
                    placeholder="Code"
                    name="code"
                    value={form.code}
                    maxLength="8"
                    onInput={utils.maxLengthCheck}
                    focus={!!(typeof formError === "object" && formError?.code)}
                    error={
                      !!(typeof formError === "object") ? formError?.code : ""
                    }
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    disabled={id?.view}
                  />
                  <p className="_btmInput_para">Leave Blank For Autogenerate</p>
                </div>

                <div className="singleDiv">
                  <CustomSelect
                    options={listData?.zoneList}
                    name="zone_id"
                    flotingLabel="Zone"
                    value={
                      form?.zone_id
                        ? listData?.zoneList?.find(
                          (i) => i?.value == form?.zone_id
                        )
                        : {}
                    }
                    error={formError["zone_id"]}
                    onSelect={(data) => handleOnChange("zone_id", data?.value)}
                    placeholder="Select Zone"
                    disabled={id?.view}
                  />
                </div>
                <div className="singleDiv">
                  {/* <CustomSelect
                    options={listData?.branchList}
                    name="branch_id"
                    flotingLabel="Branch"
                    value={
                      form?.branch_id
                        ? listData?.branchList?.find(
                          (i) => i?.value == form?.branch_id
                        )
                        : {}
                    }
                    error={formError["branch_id"]}
                    onSelect={(data) =>
                      handleOnChange("branch_id", data?.value)
                    }
                    placeholder="Select Branch"
                    disabled={id?.view}
                  /> */}
                  <CityDropdownForTrip
                    label={"Branch"}
                    placeholder="Branch"
                    fetchData={fetchBranch}
                    pageSize={20}
                    onChange={(data) => handleOnChange("branch_id", data?.value)}
                    selectedItem={form?.branch_id
                      ? listData?.branchList?.find(
                        (i) => i?.value == form?.branch_id
                      )
                      : {}}
                    error={formError["branch_id"]}
                    errorMessage={formError["branch_id"]}
                    disabled={id?.view}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="offcanvas-footer">
        {activeTab == 3 ? (
          <React.Fragment>
            {!id?.isDetailsOnly && (
              <AddButton
                onClick={(e) => handleClick(e, "add")}
                disabled={id?.view || loading}
                buttonTitle={
                  addRecord == "add" && loading
                    ? " Loading... "
                    : props?.id?.id
                      ? "Update Address"
                      : "Add Address"
                }
                className={
                  addRecord == "add" && loading ? "_addNewComm_btn_disable_" : "_addNewComm_btn"
                }
              />
            )}

            {!props?.id?.id && (
              <button
                className={
                  isButtonDisabled
                    ? "_addNewComm_btn_disable_"
                    : "_addNewComm_btn"
                }
                onClick={(e) => handleClick(e, "new")}
                disabled={id?.view || isButtonDisabled || loading}
              >
                {addRecord == "new" && loading ? " Loading... " : 'Add & New'}
              </button>
            )}
            <AddButton
              onClick={onClose}
              buttonTitle="Cancel"
              className={
                addRecord == "new" && loading ? "_addNewComm_btn_disable_" : "_cancel_btn"
              }
            />
          </React.Fragment>
        ) : (activeTab == 2 ? (
          <React.Fragment>
            {!id?.isDetailsOnly && (
              <AddButton
                onClick={handleClickContinueActiveTab}
                buttonTitle="Continue"
                disabled={id?.view || loading}
                className={
                  loading ? "_addNewComm_btn_disable_" : "_addNewComm_btn"
                }
              />
            )}
            <AddButton
              onClick={onClose}
              buttonTitle="Cancel"
              className={
                loading ? "_addNewComm_btn_disable_" : "_cancel_btn"
              }
            />
          </React.Fragment>
        ) :
          <React.Fragment>
            {!id?.isDetailsOnly && (
              <AddButton
                onClick={handleClickContinue}
                buttonTitle="Continue"
                disabled={id?.view || loading}
                className={
                  loading ? "_addNewComm_btn_disable_" : "_addNewComm_btn"
                }
              />
            )}
            <AddButton
              onClick={onClose}
              buttonTitle="Cancel"
              className={
                loading ? "_addNewComm_btn_disable_" : "_cancel_btn"
              }
            />
          </React.Fragment>
        )}
      </div>
      {showGoogleMapModal && <AddMapLocationModal {...gmapLocate} />}
      {openLoction && <AddLocationModal {...gmapLocates} />}

    </>
  );
};

export default AddAddressBook;
